var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 126,
    viewBox: "0 0 291 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3798_72139)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.649 117.608L285.605 105.852L290.153 109.497L277.406 126.23L263 109.196L266.96 106.152L276.649 117.608Z",
    fill: "#FFE672"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.538 73.1853C17.1398 62.0357 -4.07443 36.6602 0.764108 0L6.13004 0.710353C1.68403 34.3965 20.9259 57.6997 47.5135 68.1385C74.2418 78.6326 107.969 75.9011 131.533 57.5579C159.796 35.5563 196.717 25.3981 226.859 34.0495C241.993 38.3931 255.363 47.4754 264.917 62.0743C274.452 76.6447 280.074 96.5354 280.074 122.355H274.662C274.662 97.3027 269.207 78.5193 260.39 65.0457C251.591 51.6005 239.334 43.2688 225.368 39.2605C197.312 31.2078 162.146 40.5932 134.854 61.8379C109.584 81.5094 73.7954 84.2797 45.538 73.1853Z",
    fill: "#FFE672"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3798_72139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 290,
    height: 126,
    fill: "white",
    transform: "translate(0.0742188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.dd18665a56a7bf67b110b97c268b14b9.svg";
export { ForwardRef as ReactComponent };